'use strict';

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/css.js
// module id = 349
// module chunks = 106